<template>
  <div id="print-area" style="padding: 32px; font-family: '微软雅黑', 'Source Han Sans', 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif; color: #222; background: #fff;">
    <h2 style="text-align:center; margin-bottom: 24px; font-size: 24px; font-weight: bold;">面试记录</h2>
    <table style="width: 100%; margin-bottom: 18px; font-size: 15px; border-collapse: collapse;">
      <tbody>
        <tr>
          <td style="padding: 6px 4px; font-weight: bold; width: 120px;">面试名称：</td>
          <td style="padding: 6px 4px;">{{ info.interviewName }}</td>
        </tr>
        <tr>
          <td style="padding: 6px 4px; font-weight: bold;">创建时间：</td>
          <td style="padding: 6px 4px;">{{ info.createTime }}</td>
        </tr>
        <tr>
          <td style="padding: 6px 4px; font-weight: bold;">面试时长：</td>
          <td style="padding: 6px 4px;">{{ durationStr }}</td>
        </tr>
        <tr>
          <td style="padding: 6px 4px; font-weight: bold;">总答题次数：</td>
          <td style="padding: 6px 4px;">{{ info.agTotalCount }}</td>
        </tr>
        <tr>
          <td style="padding: 6px 4px; font-weight: bold;">快答次数：</td>
          <td style="padding: 6px 4px;">{{ quickCount }} 次</td>
        </tr>
        <tr>
          <td style="padding: 6px 4px; font-weight: bold;">深度回答次数：</td>
          <td style="padding: 6px 4px;">{{ deepCount }} 次</td>
        </tr>
        <tr>
          <td style="padding: 6px 4px; font-weight: bold;">截图回答次数：</td>
          <td style="padding: 6px 4px;">{{ screenshotCount }} 次</td>
        </tr>
      </tbody>
    </table>
    <hr style="margin: 18px 0; border: none; border-top: 1.5px solid #e0e0e0;">
    <h3 style="margin-bottom: 12px; font-size: 18px; font-weight: bold;">答题历史记录</h3>
    <table border="1" style="width:100%;border-collapse:collapse;font-size:14px;">
      <thead>
        <tr style="background:#f0f2f5;">
          <th style="padding:8px 4px; font-weight: bold;">问题</th>
          <th style="padding:8px 4px; font-weight: bold;">快答内容</th>
          <th style="padding:8px 4px; font-weight: bold;">深度思考内容</th>
          <th style="padding:8px 4px; font-weight: bold;">截图回答内容</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in answerRows" :key="row[0]">
          <td style="padding:8px 4px;vertical-align:top;white-space:pre-line;">{{ row[0] }}</td>
          <td style="padding:8px 4px;vertical-align:top;white-space:pre-line;" v-html="row[1]"></td>
          <td style="padding:8px 4px;vertical-align:top;white-space:pre-line;" v-html="row[2]"></td>
          <td style="padding:8px 4px;vertical-align:top;white-space:pre-line;" v-html="row[3]"></td>
        </tr>
        <tr v-if="!answerRows || answerRows.length === 0">
          <td colspan="4" style="text-align:center; color:#aaa; padding: 16px 0;">暂无答题记录</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'InterviewPrint',
  props: {
    info: { type: Object, required: true },
    quickCount: { type: Number, required: true },
    deepCount: { type: Number, required: true },
    screenshotCount: { type: Number, required: true },
    answerRows: { type: Array, required: true }
  },
  computed: {
    durationStr() {
      const { createTime, endTime } = this.info;
      if (!createTime) return '';
      const start = new Date(createTime.replace(/-/g, '/')).getTime();
      let end;
      if (endTime) {
        end = new Date(endTime.replace(/-/g, '/')).getTime();
      } else {
        end = Date.now();
      }
      if (isNaN(start) || isNaN(end) || end <= start) return '';
      let diff = Math.floor((end - start) / 1000); // 秒
      const minutes = Math.floor(diff / 60);
      return `${minutes}分钟`;
    }
  }
}
</script>

<style scoped>
#print-area {
  background: #fff;
}
</style> 